// extracted by mini-css-extract-plugin
module.exports = {"player_box":"index_player_box_1uOQP"};